import React from 'react';
import { Box } from 'rebass';
import { Controller, Scene } from 'react-scrollmagic';

const FadeWrapper = ({ children }) => (
  <Controller globalSceneOptions={{ triggerHook: 'onEnter' }}>
    <Scene classToggle="full-opacity">{children}</Scene>
  </Controller>
);

/**
 * Manages scroll effects
 * @param {Object} props
 * @param {boolean} props.container - custom container to render
 * @param {boolean} props.shouldFade
 */
const OpacityController = ({
  children,
  container = Box,
  shouldFade,
  ...props
}) => {
  const Container = container;

  return shouldFade ? (
    <FadeWrapper>
      <Container
        {...props}
        className={
          props.className ? `${props.className} zero-opacity` : 'zero-opacity'
        }
      >
        {children}
      </Container>
    </FadeWrapper>
  ) : (
    <Container {...props}>{children}</Container>
  );
};

export default OpacityController;
